import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FiMenu, 
  FiX, 
  FiHome, 
  FiBook, 
  FiUser, 
  FiSettings, 
  FiLogOut,
  FiBell,
  FiSun,
  FiMoon,
  FiSearch
} from 'react-icons/fi';
import { useTheme } from '../../contexts/ThemeContext';
import Button from '../common/Button';
import { removeUser, getUser } from '../../utils/helpers';
import { authAPI } from '../../api/endpoints';
import logo from '../../assets/images/logo.png';
import {
  LayoutContainer,
  Sidebar,
  SidebarHeader,
  Logo,
  SidebarNav,
  NavItem,
  SidebarFooter,
  MainContent,
  TopBar,
  MenuButton,
  TopBarRight,
  IconButton,
  UserProfile,
  UserAvatar,
  UserInfo,
  ContentArea,
} from './DashboardLayout.styles';

const DashboardLayout = ({ children, menuItems = [] }) => {
  const navigate = useNavigate();
  const { isDarkMode, toggleTheme } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const user = getUser();

  const handleLogout = async () => {
    try {
      // Call backend logout to clear cookies
      await authAPI.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear user data from localStorage
      removeUser();
      navigate('/login');
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <LayoutContainer>
      <Sidebar isOpen={sidebarOpen}>
        <SidebarHeader>
          <Logo>
            <img src={logo} alt="Dira Learners Logo" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
          </Logo>
        </SidebarHeader>

        <SidebarNav>
          {menuItems.map((item, index) => (
            <NavItem
              key={index}
              active={item.active || window.location.pathname === item.path}
              onClick={() => {
                if (item.onClick) {
                  item.onClick();
                } else if (item.path) {
                  navigate(item.path);
                }
                setSidebarOpen(false);
              }}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavItem>
          ))}
        </SidebarNav>

        <SidebarFooter>
          <NavItem onClick={handleLogout}>
            <FiLogOut />
            <span>Logout</span>
          </NavItem>
        </SidebarFooter>
      </Sidebar>

      <MainContent>
        <TopBar>
          <MenuButton onClick={toggleSidebar}>
            {sidebarOpen ? <FiX /> : <FiMenu />}
          </MenuButton>

          <TopBarRight>
            {/* Browse Courses CTA for learners */}
            {user?.role === 'student' && (
              <Button 
                size="small" 
                onClick={() => navigate('/learner/browse')}
                style={{ background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)' }}
              >
                Browse Courses
              </Button>
            )}

            <IconButton onClick={toggleTheme}>
              {isDarkMode ? <FiSun /> : <FiMoon />}
            </IconButton>

            <IconButton>
              <FiBell />
              <span className="badge">3</span>
            </IconButton>

            <UserProfile>
              <UserAvatar>
                {user?.name?.charAt(0).toUpperCase() || 'U'}
              </UserAvatar>
              <UserInfo>
                <p className="name">{user?.name || 'User'}</p>
                <p className="role">{user?.role?.replace('_', ' ') || 'User'}</p>
              </UserInfo>
            </UserProfile>
          </TopBarRight>
        </TopBar>

        <ContentArea>{children}</ContentArea>
      </MainContent>

      {sidebarOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 998,
          }}
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </LayoutContainer>
  );
};

export default DashboardLayout;

